import React from "react";
import InputTextField from "../inputTextField/InputTextField";
import { getProductSubCategory, isSystemProduct } from "../../utility";

const SerialNumber = (props) => {
  const { priceChartingProductInfo , handleChange} = props;
  const productMetaData = priceChartingProductInfo.productMetaData
    ? priceChartingProductInfo.productMetaData
    : priceChartingProductInfo;

  return (
    isSystemProduct(getProductSubCategory(productMetaData?.genre)) && (
      <>
        <InputTextField
          name="serialNumber"
          maxLength={100}
          placeHolder="Enter Serial Number"
          className="border"
          containerDivClassName="modal-input-field-min-width"
          handleChange={handleChange}
        />
      </>
    )
  );
};

export default SerialNumber;
